<div class="info-banner" *ngIf="visible" role="status">
  <button
    type="button"
    class="info-banner__close"
    [attr.aria-label]="'dashboard.info_banner.close' | translate"
    (click)="dismiss()"
  >
    &times;
  </button>
  <p class="info-banner__line" *ngFor="let line of lines">{{ line }}</p>
</div>
